/* src/app/home/imp-terms-static/imp-terms-static.component.scss */
.imp-modal {
  position: fixed;
  top: 5px;
  right: 5px;
  bottom: 5px;
  left: 5px;
  z-index: 1000;
  overflow: auto;
}
.imp-modal .imp-modal-body {
  padding: 20px;
  background: var(--ion-background-color);
  color: white;
  margin: 40px;
}
.imp-modal .imp-close-button-icon {
  background: var(--ion-background-color);
  color: var(--ion-color-primary);
  overflow: hidden;
  font-size: calc(1.5 * (1vh + 1vw + 1vmin));
}
.imp-modal #imp-modal-close-button {
  position: fixed;
  top: 60px;
  right: 70px;
  background-color: var(--ion-background-color);
}
.imp-modal-background {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: var(--ion-text-color);
  opacity: 0.75;
  z-index: 900;
}
/*# sourceMappingURL=imp-terms-static.component.css.map */
